module.exports = __webpack_public_path__ + "static/img/hotelDetailsDf.a5559ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hotelDetailsDf.png
// module id = pMap
// module chunks = 1